import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { FadeInWrapper, Footer, LoadingIcon, Main, MainContent, Section } from "@prosolve/common-components-ui";
import useIsMobileView from "../../hooks/useIsMobileView";
import useShipmentSnackbar from "../Shared/useShipmentSnackbar";
import useFetchOpportunities from "../Shared/useFetchOpportunities";
import OpportunityCards from "./OpportunityCards";
import OpportunityFilters from "./OpportunityFilters";
//import RefreshOpportunityButton from "./RefreshOpportunityButton";
import RefreshShippingButton from "../Shared/RefreshShippingButton";

const SectionDivider = () => <div style={{ height: '10px' }}>&nbsp;</div>

export default function Opportunities ({
  shipModals
}) {
  const isMobileView = useIsMobileView();
  const shipmentSnackbar = useShipmentSnackbar()
  const { fetchOpportunities: fetchOpportunitiesHook } = useFetchOpportunities()
  
  const [searchParams] = useSearchParams()
  const [reportType, setReportType] = useState(searchParams.get('reportType'))
  const territory = Cookies.get('territory')

  const [isLoading, setIsLoading] = useState(true)
  const [isOpportunityDataAvailable, setIsOpportunityDataAvailable] = useState(false)
  const [opportunities, setOpportunities] = useState([])
  const [filteredOpportunities, setFilteredOpportunities] = useState(opportunities)

  const probability = searchParams.get('probability') || ''
  const isRemainingToShip = (searchParams.get('isRemainingToShip') || 'true') === 'true'
  const [filter, setFilter] = useState({ probability, isRemainingToShip, ...(reportType ? { reportType } : {}) })

  const fetchOpportunities = async () => {
    setIsLoading(true)
    try {
      //console.log('filter', filter)
      const resultJson = await fetchOpportunitiesHook({ limit: 50, territory, ...filter })
      //const resultJson = await fetchOpportunitiesHook()
      setOpportunities(resultJson)
      setFilteredOpportunities(resultJson)
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error getting opportunities', severity: 'failure' })
    } finally {
      setIsOpportunityDataAvailable(true)
    }
  }

  const onFilteredOpportunitiesChange = (newFilteredOpportunities, filter) => {
    //setFilteredOpportunities(newFilteredOpportunities)
    setFilter(filter)
    if (isOpportunityDataAvailable) setIsLoading(false)
  }

  const onRefreshStart = () => {
    setIsLoading(true)
  }

  const onRefreshComplete = () => {
    fetchOpportunities()
  }

  const onOpportunityUpdate = (opportunity) => {
    const clonedOpps = [...opportunities]
    const index = clonedOpps.findIndex(o => o.Id === opportunity.Id)
    console.log('onOpportunityUpdate', index, opportunity)
    if (index > -1) clonedOpps[index] = opportunity
    setOpportunities(clonedOpps)
  }

  useEffect(() => {
    fetchOpportunities()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  useEffect(() => {
    setReportType(searchParams.get('reportType'))
  }, [searchParams])

  return (
    <Main $isMobileView={isMobileView} $backgroundColor={'inherit'} style={{ padding: '10px' }}>
      <MainContent $isMobileView={isMobileView}>
        <div style={{ alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ display: 'flex' }}>
            <div style={{ flexGrow: 1, fontSize: '28px', fontWeight: 'bold' }}>
              {'Manage Opportunities'}
            </div>
            <div style={{ fontSize: '1rem' }}>
              {/*<RefreshOpportunityButton text='Refresh All Opportunities' onRefreshStart={onRefreshStart} onRefreshComplete={onRefreshComplete} />*/}
              <RefreshShippingButton onStart={onRefreshStart} onComplete={onRefreshComplete} />
            </div>
          </div>
          <div style={{ color: 'gray', fontSize: '0.8em', marginTop: '5px' }}>
            {'(Up to 50 entries displayed at a time)'}
          </div>
        </div>
        <div>
          <OpportunityFilters filter={{ reportType, probability, isRemainingToShip }} opportunities={opportunities} onFilteredOpportunitiesChange={onFilteredOpportunitiesChange} />
        </div>
        <div style={{ padding: '0' }}>
        { 
          isLoading 
          ?
          <Section style={{ background: 'inherit', height: '1200px', alignItems: 'center' }}>
            <LoadingIcon />
          </Section>
          :
          !filteredOpportunities?.length ?
          <Section style={{ background: 'inherit', height: '400px' }}>
            Unable to find opportunityData data
          </Section>
          :
          <FadeInWrapper>
            <Section style={{ background: 'inherit', padding: '0px' }}>
              <OpportunityCards opportunities={filteredOpportunities} onOpportunityUpdate={onOpportunityUpdate} shipModals={shipModals} />
            </Section>
          </FadeInWrapper>
        }
        </div>
        <SectionDivider />
        <Footer />
      </MainContent>
    </Main>
  )
}